export default "__VITE_ASSET__CfLYIddw__"